<div style="text-align: center;">
    <span>Etes-vous certain de vouloir certifier le client {{this.name}}?</span>
    <div>
        <button (click)="certifier()" style="margin: 5px;">Oui</button>
        <button (click)="back()" style="margin: 5px;">Non</button>
    </div>
</div>
